define('webshopLandingpagesListFiltersEditView',[
  'app',
  'module',
  'backbone',
  'settings',
  'underscore',
  'selectView',
  'checkboxView',
  'webshopCategorySelectView',
  'filtersBannerEditView',
  'template!webshopLandingpagesListFiltersEditView',
  'entities/webshop/landingpages'
], function(
  App,
  Module,
  Backbone,
  Settings,
  _,
  SelectView,
  CheckboxView,
  CategorySelectView,
  FiltersBannerEditView,
  Tpl
) {
  'use strict';
  
  Module.exports = FiltersBannerEditView.extend({
    template: Tpl,       
    className: 'webshop-landingpages-list-filters-edit-view ' + FiltersBannerEditView.prototype.className,
    windowTitle: _.i18n('webshop.landingpages.list.filters.edit'),

    ui: _.extend({
      code: '.body .code input',     
      category: '.body .category input'    
    }, FiltersBannerEditView.prototype.ui),

    regions: _.extend({
      statusSelectRegion: '.status .select-region',     
      categorySelectRegion: '.category-select-region'     
    }, FiltersBannerEditView.prototype.regions),   

    onRender: function() {     
      this.statusView = new SelectView({
        collection: new Backbone.Collection([
          {id: '', value: _.i18n('common.all')},
          {id: '0',  value: _.i18n('common.disabled')},
          {id: '1',  value: _.i18n('common.enabled')}
        ]),
        tabindex: 3
      });
      this.statusSelectRegion.show(this.statusView);
      this.statusView.setSelected(this.model.get('status'));  

      //----------------    
      this.categorySelectView = new CategorySelectView({
        model: new Backbone.Model({
          id: this.model.get('category').id,
          code: this.model.get('category').code
        })       
      });
      
      this.getRegion('categorySelectRegion').show(this.categorySelectView);

      //----------------
      this.ui.code.val(this.model.get('code'));  

      //----------------
      FiltersBannerEditView.prototype.onShow.apply(this, arguments);
    },

    onConfirm: function() {    
      this.model.set({
        status: this.statusView.getSelected().get('id'),       
        code: this.ui.code.val().trim(),       
        category: {
          id: this.categorySelectView.model.get('id'),
          code: this.categorySelectView.model.get('code')
        }      
      });

      FiltersBannerEditView.prototype.onConfirm.apply(this, arguments);
    },

    onReset: function() {
      this.statusView.setSelected('');    
      this.ui.code.val('');   
      this.model.set('category', {id: '', code: ''});    
    }
  });  
});

